export default {
  strapiMedia: process.env.VUE_APP_STRAPI_MEDIA || 'https://larvaio-strapi.azurewebsites.net/',
  strapiURL: process.env.VUE_APP_STRAPI_API_URL || 'https://larvaio-strapi.azurewebsites.net/api',
  cdnReplacementSrc: 'https://larva-strapi.s3.eu-central-1.amazonaws.com',
  cdnReplacementDst: 'https://assets.www.fentrica.com',
};
